// src/data/comedians/eddie-murphy.js

const base = {
  id: 'eddie-murphy',
  slug: 'eddie-murphy',
  name: 'Eddie Murphy',
  birthYear: 1961,
  image: require('@/assets/images/img_Eddie_Murphy.jpg'),
  famousWorks: [
    'Saturday Night Live (1980–1984)',
    'Beverly Hills Cop series',
    'Coming to America',
    'The Nutty Professor',
    'Shrek franchise',
    'Delirious (1983)',
    'Raw (1987)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'American',
    shortBio: 'Stand-up legend and SNL icon',
    bio: `Eddie Murphy is an American actor, comedian, and singer who rose to fame on Saturday Night Live in the early 1980s. Known for his energetic and versatile performances, Murphy became one of the most successful comedians and actors of his generation.\n\nBorn in Brooklyn, New York, Murphy began his career doing stand-up comedy as a teenager. His breakthrough came when he joined SNL at age 19, where his characters and impressions became instant classics.\n\nMurphy's film career includes iconic roles in "48 Hrs.", "Trading Places", "Beverly Hills Cop", "Coming to America", "The Nutty Professor", and the "Shrek" franchise. His comedy specials "Delirious" (1983) and "Raw" (1987) are considered among the greatest stand-up performances ever recorded.`,
    style: 'Energetic, character-driven, observational comedy with sharp impressions',
    achievements: [
      'Golden Globe Award winner',
      'Emmy Award winner',
      'Mark Twain Prize for American Humor (2015)',
      'Hollywood Walk of Fame star',
      'One of highest-grossing actors of all time',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Américain',
    shortBio: 'Légende du stand-up et icône du SNL',
    bio: `Eddie Murphy est un acteur, comédien et chanteur américain qui a connu la célébrité grâce au Saturday Night Live au début des années 1980. Connu pour ses performances énergiques et polyvalentes, Murphy est devenu l'un des comédiens et acteurs les plus accomplis de sa génération.\n\nNé à Brooklyn, New York, Murphy a commencé sa carrière dans la comédie stand-up à l'adolescence. Sa percée est venue lorsqu'il a rejoint le SNL à 19 ans, où ses personnages et imitations sont devenus des classiques instantanés.\n\nSa carrière cinématographique comprend des rôles emblématiques dans « Le Flic de Beverly Hills », « Un prince à New York », « The Nutty Professor » et la franchise « Shrek ». Ses spectacles « Delirious » (1983) et « Raw » (1987) sont considérés parmi les plus grandes performances de stand-up jamais enregistrées.`,
    style: 'Comédie énergique, personnages hauts en couleur, observations acérées et imitations',
    achievements: [
      'Lauréat du Golden Globe Award',
      'Lauréat de l\'Emmy Award',
      'Mark Twain Prize for American Humor (2015)',
      'Étoile sur le Hollywood Walk of Fame',
      'L\'un des acteurs les plus rentables de tous les temps',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Americano',
    shortBio: 'Leyenda del stand-up e ícono del SNL',
    bio: `Eddie Murphy es un actor, comediante y cantante estadounidense que saltó a la fama en Saturday Night Live a principios de los años 80. Conocido por sus actuaciones enérgicas y versátiles, Murphy se convirtió en uno de los comediantes y actores más exitosos de su generación.\n\nNacido en Brooklyn, Nueva York, Murphy comenzó su carrera en el stand-up durante su adolescencia. Su gran oportunidad llegó cuando se unió al SNL a los 19 años, donde sus personajes e imitaciones se convirtieron en clásicos instantáneos.\n\nSu carrera cinematográfica incluye papeles icónicos en "Superdetective en Hollywood", "Un príncipe en Nueva York", "The Nutty Professor" y la franquicia "Shrek". Sus especiales "Delirious" (1983) y "Raw" (1987) son considerados entre las mejores actuaciones de stand-up jamás grabadas.`,
    style: 'Comedia enérgica, personajes definidos, humor observacional con imitaciones precisas',
    achievements: [
      'Ganador del Golden Globe Award',
      'Ganador del Emmy Award',
      'Mark Twain Prize for American Humor (2015)',
      'Estrella en el Paseo de la Fama de Hollywood',
      'Uno de los actores con mayor recaudación de todos los tiempos',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'أمريكي',
    shortBio: 'أسطورة الستاند أب وأيقونة SNL',
    bio: `إيدي مورفي ممثل وكوميدي ومغنٍّ أمريكي اشتهر بفضل برنامج Saturday Night Live في مطلع الثمانينيات. عُرف بأدائه المفعم بالطاقة والتنوع، وأصبح واحدًا من أنجح الكوميديين والممثلين في جيله.\n\nوُلد في برونكلين بنيويورك، وبدأ مسيرته في الكوميديا الارتجالية منذ مراهقته. جاء اختراقه الكبير حين انضم إلى SNL في التاسعة عشرة من عمره، حيث أصبحت شخصياته وتقليداته كلاسيكياتٍ فورية.\n\nتضمّ مسيرته السينمائية أدوارًا أيقونية في أفلام "Beverly Hills Cop" و"Coming to America" و"The Nutty Professor" وامتياز "Shrek". وتُعدّ عروضه الكوميدية "Delirious" (1983) و"Raw" (1987) من بين أعظم عروض الستاند أب المسجّلة على الإطلاق.`,
    style: 'كوميديا حيوية مدفوعة بالشخصيات، ملاحظات ثاقبة وتقليد بارع',
    achievements: [
      'فائز بجائزة Golden Globe',
      'فائز بجائزة Emmy',
      'جائزة مارك توين للفكاهة الأمريكية (2015)',
      'نجمة على ممشى المشاهير في هوليوود',
      'أحد أعلى الممثلين إيرادًا في التاريخ',
    ],
  },
];
